import { OnInit, OnDestroy } from '@angular/core';
import { Component } from '@angular/core';
import { AfterViewInit } from '@angular/core';
import { IContextService, PershingTranslationService } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { vendors } from '../../fixtures/mock-da-vendor-data';

declare let dojoApp: any;

@Component({
    selector: 'dojo-da-tools',
    templateUrl: './dojo-da-tools.component.html'
})
export class DojoDaToolsComponent implements OnInit, AfterViewInit, OnDestroy {
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    acctRef: any;
    constructor(
        private contextService: IContextService,
        private translationService: PershingTranslationService,
        private nxiRestService: NxiRestService
    ) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
    }

    ngOnInit() {
        this.getDAToolsParams();
    }

    ngAfterViewInit(): void {
    }

    ngOnDestroy(): void {
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (dojoApp) {
            dojoApp.destroyWidget('daTools');
        }
    }

    getVendors() {
        // TODO: Swap this once NXI rest ready.
        // this.nxiRestService.getDaVendors().subscribe(
        //     response => {
        //         return response;
        //     }
        // );
        return vendors;
    }

    renderDojoWidget(daOverviewParams: any) {
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.renderDaTools(daOverviewParams);
        }
    }

    getDAToolsParams() {
        this.nxiRestService.getNxiRestUrlResponse(this.nxiRestService.serviceUrl + '/portfolio/daVendorsList').subscribe(
                resp => {
                    console.log('Retrieved common REST DA Overview widgets param : ', resp.response);
                    if (resp.response) {
                        for (let i = 0; i < resp.response.vendors.length; i++) {
                            resp.response.vendors[i].preloginUrl = '/nxi/' + resp.response.vendors[i].preloginUrl ;
                            resp.response.vendors[i].postloginAccessUrl = '/nxi/' + resp.response.vendors[i].postloginAccessUrl ;
                            resp.response.vendors[i].postloginExploreUrl = '/nxi/' + resp.response.vendors[i].postloginExploreUrl ;
                        }
                        resp.pageName = 'digital-advice';
                        this.renderDojoWidget(resp.response);
                }
            }
        );
    }

}
